<template>
  <section class="item-certitifaction">
    <div class="d-flex">
      <div class="information">
        <h3>{{ item.name }}</h3>
        <h5>{{ item.institution }}</h5>
        <h5>{{ item.date }}</h5>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props:{
      item: {}
    },
    data() {
      return {
        title: 'Real-Time Multiple Vehicle Counter using Background Subtraction for Traffic Monitoring System',
        publisher : 'IEEE',
        date: 'September 2019'
      };
    },
  };
</script>

<style lang="scss">
.item-certitifaction{
  padding: .7rem 1rem;
  align-self: baseline;
  width: 100%;
  border-left: 10px solid var(--theme-deafult);
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .d-flex{
    gap: 10px;
  }
  .information{
    flex: 1;
    h3{
      font-size: 1rem;
      color: var(--theme-deafult);
    }

    h5{
      font-size: .8rem;
      font-weight: 400;
    }
  }

  .item-skill{
    flex: 1;
    h3{
      font-size: 0.8rem;
      font-weight: 500;
    }

    .d-flex{
      flex-wrap: wrap;

      h5{
        padding: 0.2rem 1rem;
        background: var(--theme-deafult);
        color: var(--theme-font);
        font-size: 0.6rem;
        border-radius: 1rem !important;
        margin-bottom: 0;
      }
    }
  }
}
</style>
